import { Media } from '../components/Media';
import { maxMobileMediaQuery } from '../styles';
export function useResponsivePropValue(responsiveProp) {
  const isResponsivePropArray = Array.isArray(responsiveProp);
  const isResponsivePropObject = typeof responsiveProp === 'object' && !isResponsivePropArray;
  let customMedia = isResponsivePropObject ? Object.keys(responsiveProp).find(breakpointKey => !['desktop', 'mobile'].includes(breakpointKey)) : '';
  customMedia = customMedia ?? '';
  const [isMobile, isCustomMedia] = Media.useIsMediaQueries([maxMobileMediaQuery(), customMedia]);
  if (isResponsivePropArray) {
    return isMobile ? responsiveProp[0] : responsiveProp[1];
  }
  if (isResponsivePropObject) {
    const responsiveObject = responsiveProp;
    return isMobile ? responsiveObject.mobile : isCustomMedia ? responsiveObject[customMedia] : responsiveObject.desktop;
  }
  return responsiveProp;
}